const fmt = (iso) => new Date(iso).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" });

export const LeadsTable = ({ leads }) => (
  <section className="stats-card stats-leads" data-testid="stats-leads">
    <div className="stats-card-head">
      <h2>Leads del formulario "Empezar gratis"</h2>
      <span data-testid="stats-leads-summary">{leads.total.toLocaleString("es-MX")} en total · {leads.today} hoy</span>
    </div>
    {leads.items.length === 0 ? (
      <p className="stats-empty" data-testid="stats-leads-empty">Aún no hay registros. Cuando alguien llene el formulario aparecerá aquí.</p>
    ) : (
      <table>
        <thead>
          <tr><th>Fecha</th><th>Nombre</th><th>WhatsApp</th><th>Ciudad</th><th>Restaurante</th><th>Plan</th><th>Evento / origen</th></tr>
        </thead>
        <tbody>
          {leads.items.map((l, i) => (
            <tr key={`${l.ts}-${i}`} data-testid={`stats-lead-row-${i}`}>
              <td className="whitespace-nowrap text-gray-500">{fmt(l.ts)}</td>
              <td className="font-semibold">{l.name}</td>
              <td><a href={`https://wa.me/52${l.whatsapp}`} target="_blank" rel="noopener noreferrer" className="text-brand-green font-semibold hover:underline">{l.whatsapp}</a></td>
              <td>{l.city || "—"}</td>
              <td>{l.restaurant || "—"}</td>
              <td>{l.plan ? <span className="stats-lead-event">{l.plan}</span> : "—"}</td>
              <td>{l.event ? <span className="stats-lead-event">{l.event}</span> : <span className="text-gray-400 text-xs">{l.source || "—"}</span>}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </section>
);

export default LeadsTable;
